<template>
  <w-sliding-popup ref="slidingPopup" type="setting" title="이벤트 임계치 가이드" width="800px" :default-content="false" @close="onClosePopup">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <w-threshold-analysis-rslt-component :selectObjThreshold="targetThreshold" :isGuideRsltType="true"/></w-threshold-analysis-rslt-component>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import WThresholdAnalysisRsltComponent from '@/components/popup/ResourceSmartAnalyzerPopup/components/ThresholdAnalysisRsltComponent';

export default {
  name: 'WThresholdGuideRsltPopup',
  components: {
    WThresholdAnalysisRsltComponent,
  },
  props: {
    selectObjThreshold: Object,
    // true인 경우 결과 / false인 경우 ondemand
    isGuideRsltType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      targetThreshold: null,
    };
  },
  watch: {
    selectObjThreshold: {
      handler(value) {
        if (!isNil(value)) {
          this.targetThreshold = value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
    },
    onClosePopup() {
      this.$emit('initPopupInfo');
      this.targetThreshold = null;
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/popup/ThresholdGuideRsltPopup.vue